<template>
    <div>
        <label class="form-control-label">Lookup Address:</label>
        <set-location mode="place" @onPlaceSet="setPlace" show-sub-text></set-location>

        <base-alert type="warning" v-if="isGoogleMapsAddress">
          <span>Please double-check that the address is copied correctly.</span>
        </base-alert>
        
        <base-input name="address" rules="required" label="Address:" v-model="address.lineOne"></base-input>
        <base-input v-model="address.lineTwo"></base-input>

        <base-input name="postCode" rules="required" label="Postcode:" v-model="address.postCode"></base-input>
        <base-input name="suburb" rules="required" label="Suburb:" v-model="address.city"></base-input>
        
        <div class="form-group">
            <label class="form-control-label">State:</label>
            <base-input v-model="address.state"></base-input>
        </div>

        <base-input name="country" rules="required" label="Country:" v-model="address.country"></base-input>
    </div>
</template>

<script>
import { states } from '@/config/Place'
import BaseAlert from '../BaseAlert.vue';
export default {
  name: 'form-address',
  components: {
    BaseAlert
  },
  props: {
    address: {
      type: Object,
      default: null,
      description: ''
    }
  },
  data() {
    return {
      isGoogleMapsAddress: false,
      showLookUp: false,
      place: null,
      states: [
          ...[{
              value: "",
              text: "Select..."
          }],
          ...states.map(function(r) {
              return {
                  value: r,
                  text: `${r}`,
              }
          })
      ]
    };
  },
  methods: {
    setPlace(place) {
      this.place = place

      this.setAddress()
    },

    reconfirmAddress(output) {
      const { name } = this.place;

      if (!name) return false

      const placeValues = Object.values(output);

      const exist = placeValues.find((f) => f.toLowerCase().trim() === name.toLowerCase().trim());

      return !exist;
    },
    
    setAddress() {
        this.showLookUp = false
      var output = {
          "lineTwo": ""
      }
      var equivalence = {
          "street_number": "lineOne",
          "route": "lineOne",
          "locality": "city",
          "administrative_area_level_1": "state",
          "postal_code": "postCode",
          "country": "country"
      }
      for(var component in this.place.address_components) {
          var shortComponent = this.place.address_components[component].types[0]
          if(shortComponent in equivalence) {
              var existingVal = output[equivalence[shortComponent]] != undefined ? output[equivalence[shortComponent]]+" " : ""
              output[equivalence[shortComponent]] = existingVal+this.place.address_components[component].short_name;
          } 
      }

      this.isGoogleMapsAddress = this.reconfirmAddress(output)

      this.$emit('onSetAddress',output)
    }
  }
};
</script>
